<script>
import { fly } from 'svelte/transition';
import Icon from '$lib/Icon.svelte';
import Flag from '$lib/Flag.svelte';
import { map_flyToDataTarget } from '$lib/app/lib.js';

let {
    db = [],
    user_stats = {},
    header = null,
    total = 0,
    switch_state = $bindable(1),
    is_collapsed = $bindable(false),
    un193_only = false,
    hoveredRegIntId = $bindable(),
    map = $bindable(null),
} = $props();


let visited = $derived(header ? db.reduce(function(acc, cv) { return acc + (user_stats[cv.id] ? 1 : 0) }, 0) : 0);


let is_accordion_enabed = $derived.by(() => {
    let is_accordion_enabed = false;
    for (const rrow of db) {
        // 1..2..3 == Visited...All...ToGo
        if((switch_state<3&&user_stats?.[rrow['id']]) || (switch_state>1&&!user_stats?.[rrow['id']])) {
            is_accordion_enabed = true;
            break;
        }
    }
    return is_accordion_enabed;
});

</script>
<table class='table been-table'>
    <tbody>
        {#if header}
        <tr class='tcc-region-header' onclick={(e) => {e.preventDefault(); is_collapsed = !is_collapsed}}>
            <td class='py-1' colspan=2>
                <div class='flex-container'>
                    <span>
                        <b>{header}</b> &mdash;
                        {#if switch_state == 3}
                        {#key visited}<span style="display: inline-block" in:fly|local={{ y: -20 }}>{total-visited}</span>{/key} / {total} (<span>{Math.round((total-visited) / total * 100)}</span>%)
                        {:else}
                        {#key visited}<span style="display: inline-block" in:fly|local={{ y: -20 }}>{visited}</span>{/key} / {total} (<span>{Math.round(visited / total * 100)}</span>%)
                        {/if}
                    </span>
                    <span class=has-text-right>
                        <Icon id={is_accordion_enabed ? (is_collapsed ? "angle-down" : "angle-up") : ""}/>
                    </span>
                </div>
            </td>
        </tr>
        {/if}
        {#if !is_collapsed}
            {#each db as rrow}
                {#if !rrow['dependent'] || !un193_only}
                    {#if (switch_state<3&&user_stats?.[rrow['id']]) || (switch_state>1&&!user_stats?.[rrow['id']])}
                        <tr data-name=UN data-value={rrow['id']} class:visited={user_stats?.[rrow['id']]}>
                            <td class='py-1'>
                                <Flag reg={rrow.id} force_unp={true}/>&nbsp;<span class="flyable-text" class:my-hover={hoveredRegIntId == rrow.int_id} onclick={(e)=>map_flyToDataTarget(map,e)} onmouseover={()=>{hoveredRegIntId=rrow.int_id}} class:is_un_plus={rrow['dependent']} data-target={rrow.id}>{rrow['name']}</span>
                            </td>
                            <td class='py-1 has-text-right'>{user_stats?.[rrow['id']]??''}</td>
                        </tr>
                    {/if}
                {/if}
            {/each}
        {/if}
    </tbody>
</table>

<style>

.flex-container {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
}
  
tr.visited { 
    background: #EBFFDE;
}

tr.tcc-region-header {
    background: #adc1eb;
}

@media (prefers-color-scheme: dark) {
    tr.visited {
        background: rgb(31, 34, 49);
    }

    tr.tcc-region-header { 
        background: rgb(40, 50, 70);
    }
}

tr.visited > td {
    font-weight: bold;
}

.flyable-text {
    cursor: zoom-in;
}

.my-hover {
    text-decoration: underline;
    text-decoration-style: double;
}
</style>